import { Component, OnInit, Input } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Utils } from "../../common/utils";

@Component({
  selector: "app-player-badge",
  templateUrl: "./player-badge.component.html",
  styleUrls: ["./player-badge.component.scss"],
})
export class PlayerBadgeComponent implements OnInit {
  VARIABLE_DASH_MAX = 226;
  _player: any;
  _stats: any;
  _bests: any;
  _variable: string;

  @Input() get player(): any {
    return this._player;
  }
  set player(player: any) {
    this._player = player;
    if (this._player) {
      // Layout temporary data
      this._player.team = "rma";

      this.calculateStats();
    }
  }
  @Input() get stats(): any {
    return this._stats;
  }
  set stats(stats: any) {
    this._stats = stats;
    this.calculateStats();
  }
  @Input() get bests(): any {
    return this._bests;
  }
  set bests(bests: any) {
    this._bests = bests;
    this.calculateStats();
  }
  @Input() get variable(): string {
    return this._variable;
  }
  set variable(variable: string) {
    this._variable = variable;
    this.calculateStats();
  }

  @Input() unit: string;

  radius = 30;
  strokeWidth = 12;
  variableDash = 0;
  reset = false;

  utils = Utils;
  resetTimeout: any;
  fillTimeout: any;

  constructor() {}

  ngOnInit() {
    this.calculateStats();
  }

  generateCirclePath(forText = false) {
    let radius;
    if (!forText) {
      radius = this.radius + this.strokeWidth / 2;
    } else {
      radius = this.radius + 2;
    }
    const pathD = `
      M ${this.radius + this.strokeWidth} ${this.radius + this.strokeWidth}
      m -${radius}, 0
      a ${radius},${radius} 0 1,1 ${radius * 2},0
      a ${radius},${radius} 0 1,1 -${radius * 2},0
    `;
    return pathD;
  }

  private calculateStats() {
    if (this._stats && this._player && this._bests && this.variable) {
      this._player.value = this._stats[this.variable]
        ? this._stats[this.variable]
        : "0";
      this._player.unit = this.variable;
      this._player.fouls = this._stats.fouls;
      this._player.foulsArr = [];
      for (let i = 0; i < 5; i++) {
        this._player.foulsArr.push(i < this._player.fouls);
      }
      if (this.variable !== "summary" && this.variable !== "rebounds") {
        this._player.best =
          this._bests[this.variable].value === this._player.value;
      } else if (this.variable === "rebounds") {
        this._player.best =
          this._bests[this.variable].value === this._stats.reboundsSum;
      }
      this.animateCircle();
    }
  }

  private animateCircle() {
    let newVariableDash;
    if (this.variable !== "rebounds" && this._bests[this.variable]) {
      newVariableDash =
        (this._player.value / this._bests[this.variable].value) *
        this.VARIABLE_DASH_MAX;
    } else if (this._bests[this.variable]) {
      newVariableDash =
        (this._stats.reboundsSum / this._bests[this.variable].value) *
        this.VARIABLE_DASH_MAX;
    }
    this.reset = true;
    this.variableDash = 0;
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout);
    }
    if (this.fillTimeout) {
      clearTimeout(this.fillTimeout);
    }
    this.resetTimeout = setTimeout(() => {
      this.reset = false;
      this.fillTimeout = setTimeout(() => {
        this.variableDash = newVariableDash;
      }, 2000);
    }, 500);
  }
}
